import React, { useEffect } from 'react'
import { Alert, Button, Typography } from 'components'
import { useNavigate } from 'react-router-dom'
import * as S from './styles'
import { URL_CONST } from 'constants/urls'
import { AuthLayout } from 'layouts/AuthLayout'

const ChangedPassword: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    localStorage.removeItem('resetPassword')
  }, [])

  return (
    <AuthLayout>
      <S.FieldsWrapper>
        <Typography className="changedPasswordTitle" design="hav-h5-text">
          Nova senha criada com sucesso!
        </Typography>
        <Typography className="changedPasswordDescription" design="hav-default-01-text">
          Agora com a nova senha você já pode acessar o sistema novamente.
        </Typography>
        <div className="changedPasswordAlert">
          <Alert
            kind="info"
            fullWidth
            title="Atenção"
            message="O código inserido para recuperar a senha é diferente do código de login, portanto, um novo código será solicitado para validar o seu acesso."
          />
        </div>
        <Button
          fullWidth
          content="Fazer login"
          type="button"
          onClick={() => navigate(URL_CONST.LOGIN)}
        />
      </S.FieldsWrapper>
    </AuthLayout>
  )
}

export default ChangedPassword
